import * as types from "../../constants";
import * as api from "../../services/APIService";

const route = "api/ChecklistTemplates/";

export function get() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLISTS_TEMPLATE_PENDING });
    return api
      .get(route)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLISTS_TEMPLATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLISTS_TEMPLATE_ERROR });
        throw error;
      });
  };
}

export function getById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLIST_TEMPLATE_PENDING });
    return api
      .getById(route, id)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLIST_TEMPLATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLIST_TEMPLATE_ERROR });
        throw error;
      });
  };
}
export function update(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_TEMPLATE_PENDING });
    return api
      .update(route, value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_CHECKLIST_TEMPLATE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_CHECKLIST_TEMPLATE_ERROR });
        throw error;
      });
  };
}

export function insert(value) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_CHECKLIST_TEMPLATE_PENDING });
    return api
      .insert(route, value)
      .then((response) => {
        dispatch({
          type: types.INSERT_CHECKLIST_TEMPLATE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_CHECKLIST_TEMPLATE_ERROR });
        throw error;
      });
  };
}

export function remove(value) {
  return async (dispatch) => {
    dispatch({ type: types.REMOVE_CHECKLIST_TEMPLATE_PENDING });
    return api
      .remove(route, value)
      .then((response) => {
        dispatch({
          type: types.REMOVE_CHECKLIST_TEMPLATE_SUCCESS,
          payload: response,
        });
        dispatch(get());
      })
      .catch((error) => {
        dispatch({ type: types.REMOVE_CHECKLIST_TEMPLATE_ERROR });
        throw error;
      });
  };
}
